<template>
  <div v-if="this.$store.state.renderComponent">
    <vue-bootstrap4-table
      :rows="rows"
      :columns="this.columns"
      :config="config"
      :classes="classes"
    >
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>

      <template slot="empty-results"> اطلاعاتی یافت نشد </template>
    </vue-bootstrap4-table>
    <div v-for="post in posts" :key="post.Id"></div>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { mapState } from "vuex";
export default {
  components: {
    VueBootstrap4Table,
  },
  computed: {
    ...mapState(["posts"]),
  },
  data() {
    return {
      DataAxoisLogRiz: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: "frmUserLogInformationRiz",
          ShowView: 0,
        },
        Method: "post",
        Action: "ReadGridColumns",
      },
      DataAxios: {},
      rows: [],
      columns: [],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [5, 10, 20, 30],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: false,
        card_title: "",
        card_mode: false,
        selected_rows_info: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: { table: "table-bordered table-striped table-sm" },
    };
  },
  methods: {
    GetCol(ListColumns) {
      this.columns = ListColumns;
    },
  },
  beforeMount() {
    this.$GetGridColumns(
      this.DataAxoisLogRiz,
      false,
      { EditMode: false, DeleteMode: false },
      this.GetCol
    );
  },
  mounted() {
    this.DataAxios.Action = "UserLogInformationRiz";
    this.DataAxios.ArryfildValue = {
      BnpCashLogId: this.$store.state.UserLogInformation.DataLogRiz[0].Id,
    };
    this.DataAxios.Method = "post";
    this.$PostData(this.DataAxios).then((data) => {
      if (data.length > 0) {
        this.rows = data;
        console.log(data);
      } else {
        console.log("No Data");
      }
    });
  },
};
</script>
<style scoped></style>
